import * as React from 'react';
import * as _ from 'lodash';
import ScriptHeader from '../../project/ScriptHeader/ScriptHeader';
import { Loader, LoaderSize, LoaderTheme } from '../../../components/Loader/Loader';
import NoContentView from '../../../components/NoContentView/NoContentView';
import { useEffect, useState } from 'react';
import { ICompredScript as IComapredScript } from '../../../../models/ICompredScript';
import { isScriptType } from '../../../../models/IScript';
const { default: noChangesIcon } = require('../../../../assets/images/diff/no-changes-script-pic@2x.png');

//@ts-ignore
const worker: Worker = new Worker(new URL('../../../../workers/script-comparer', import.meta.url));;
if (!worker) {
    throw new Error('failed to create worker');
}

interface IDiffInfo {
    addedLines: number
    deletedLines: number
    blocks: any
}

type CompareScriptAreaProps = {
    isLoading: boolean,
    script: IComapredScript
}

function CompareScriptArea({ isLoading, script }: CompareScriptAreaProps) {
    const [diffHtml, setDiffHtml] = useState<string>('');
    const [diffIsLoading, setDiffIsLoading] = useState<boolean>(true);
    const [diffInfo, setDiffInfo] = useState<IDiffInfo>(null);


    useEffect(() => {
        setDiffHtml('');
        setDiffInfo(null);
        setDiffIsLoading(true);

        const workerMessageListener = (e) => {
            if (e.data.msg === 'diffResult') {
                setDiffHtml(e.data.diffHtml);
                setDiffInfo(e.data.diffInfo);
                setDiffIsLoading(false);
            }
        };

        worker.addEventListener('message', workerMessageListener, false);

        if (!_.isEmpty(script)) {
            worker.postMessage({
                msg: 'createDiff',
                options: {
                    script: isScriptType(script) ?
                        script :
                        {
                            initialText: script.transformTextRepresentation,
                            newText: script.newTransformTextRepresentation,
                        },
                    includeHtmlDiff: true,
                    outputFormat: isScriptType(script) ? 'line-by-line' : 'side-by-side'
                }
            });
        }


        return () => {
            worker.removeEventListener('message', workerMessageListener, false);
        };
    }, [script]);

    const isScript = isScriptType(script);
    const hasChanges = (!_.isEmpty(diffInfo) && (diffInfo.addedLines > 0 || diffInfo.deletedLines > 0 || diffInfo.blocks.length > 0));

    return (
        <div className="compare-script-area">
            {(!isLoading && hasChanges && isScript) &&
                <ScriptHeader name={script.name}>
                    {!_.isEmpty(diffInfo) &&
                        <div className="compare-script-area_stats">
                            <span>Added: {diffInfo.addedLines}</span><span>Removed: {diffInfo.deletedLines}</span>
                        </div>}
                </ScriptHeader>}
            {(isLoading || diffIsLoading || !hasChanges) ?
                <div className="compare-script-area_content">
                    {(isLoading || diffIsLoading) ? <Loader theme={LoaderTheme.Dark} size={LoaderSize.Medium} center={true} appearWithFade={true} /> :
                        ((!hasChanges) && <NoContentView img={noChangesIcon} label={`No changes have been made to this ${script?.type}.`} />)}
                </div> :
                <div className="compare-script-area_content" dangerouslySetInnerHTML={{ __html: diffHtml }} />
            }
        </div>
    );
}
export default CompareScriptArea;
